import { NavLink } from "react-router-dom";
import { DISCORD_URL } from "@/lib/gp";
import { useAuth } from "@/context/AuthContext";
import {
  Home, Trophy, BarChart3, CalendarDays, BookOpen, Newspaper, MessageCircle, Shield, Bot,
} from "lucide-react";

const TABS = [
  { to: "/", label: "Home", icon: Home, end: true },
  { to: "/tournaments", label: "Tournaments", icon: Trophy },
  { to: "/leaderboard", label: "Leaderboards", icon: BarChart3 },
  { to: "/calendar", label: "Calendar", icon: CalendarDays },
  { to: "/rules", label: "Rules", icon: BookOpen },
  { to: "/news", label: "News", icon: Newspaper },
  { to: "/chat", label: "Chat", icon: Bot },
];

export default function TabBar() {
  const { user } = useAuth();
  return (
    <div className="sticky top-16 z-40 bg-gp-deep/90 backdrop-blur-md border-b border-white/10" data-testid="tab-bar">
      <div className="mx-auto max-w-[1440px] px-1 sm:px-3 md:px-8">
        <nav className="flex items-center gap-0.5 md:gap-1 overflow-x-auto gp-scroll scroll-smooth snap-x py-1" aria-label="Game navigation">
          {TABS.map((t) => {
            const Icon = t.icon;
            return (
              <NavLink
                key={t.to}
                to={t.to}
                end={t.end}
                data-testid={`tab-${t.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `snap-start shrink-0 flex items-center gap-1.5 md:gap-2 px-2.5 md:px-4 py-2.5 rounded-lg text-xs md:text-sm font-semibold whitespace-nowrap transition-colors border-b-2 ${
                    isActive ? "text-gp-blue border-gp-blue" : "text-white/60 border-transparent hover:text-white"
                  }`
                }
              >
                <Icon size={15} /> {t.label}
              </NavLink>
            );
          })}
          {DISCORD_URL ? (
            <a
              href={DISCORD_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="tab-discord"
              className="snap-start shrink-0 flex items-center gap-1.5 md:gap-2 px-2.5 md:px-4 py-2.5 rounded-lg text-xs md:text-sm font-semibold text-white/60 hover:text-[#5865F2] transition-colors border-b-2 border-transparent"
            >
              <MessageCircle size={15} /> Discord
            </a>
          ) : (
            <span
              data-testid="tab-discord"
              title="Discord is not connected yet"
              className="snap-start shrink-0 flex items-center gap-1.5 md:gap-2 px-2.5 md:px-4 py-2.5 rounded-lg text-xs md:text-sm font-semibold text-white/35 border-b-2 border-transparent cursor-default"
            >
              <MessageCircle size={15} /> Discord
            </span>
          )}
          {user && user.is_admin && (
            <NavLink
              to="/admin"
              data-testid="tab-admin"
              className={({ isActive }) =>
                `snap-start shrink-0 flex items-center gap-1.5 md:gap-2 px-2.5 md:px-4 py-2.5 rounded-lg text-xs md:text-sm font-semibold whitespace-nowrap transition-colors border-b-2 ${
                  isActive ? "text-gp-gold border-gp-gold" : "text-gp-gold/70 border-transparent hover:text-gp-gold"
                }`
              }
            >
              <Shield size={15} /> Admin
            </NavLink>
          )}
        </nav>
      </div>
    </div>
  );
}
